<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import simplebar from "simplebar-vue";
import OrdersApi from "@/services/orders-api";
import ItemsApi from "@/services/items-api";
import CustomersApi from "@/services/customers-api";
import PricesApi from "@/services/prices-api";
import OrderModal from "@/components/orderModal"
import OrdersList from "@/components/orderslist"
// import TopItems from "@/components/topItems";
// import Promotions from "@/components/promotion"; 
import {Priviliges} from "../../../privileges";
import UsersApi from "@/services/users-api";
import Order from "@/components/orderComponent"
import AnnouncementsApi from "@/services/announcements-api";
import GroupSparkLine from "@/components/groupSparkLine.vue";

import i18n from "@/i18n";

export default {
  page: {
    title: "Nouvelle Commande",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout, simplebar, OrderModal, OrdersList, Order /*,TopItems, Promotions */,GroupSparkLine
  },
  props :{
    brand: {
      type: Object,
      default: () => ({})
    },

    promotionId: {
      type: Number,
      default: 0,
    },

    filter: {
      type: String,
    },

    isHomePageRequest: {
      type: Boolean,
      default:false
    },

    isVehiculeSearch: {
      type: Boolean,
      default:false
    },

    isOEMSearch: {
      type: Boolean,
      default:false
    },

    isCompetitorSearch: {
      type: Boolean,
      default:false
    },
  },
  mounted(){

      this.role=sessionStorage.getItem("userr");
      if(sessionStorage.getItem("privileges")!=null){
        this.privileges=sessionStorage.getItem("privileges")
        this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
      }

      this.getHighlights();

      if(this.role==0){

        this.paginationOptions = [3];
        this.pagemodel= {currentPage : 1, perPage : 3, totalRows: 0},

        this.getOutstandingInfo()
        this.getCurrentYear()
        //this.findItems()
      }

      if(this.role ==1){

        this.paginationOptions = [10,15,50,100];
        this.pagemodel= {currentPage : 1, perPage : 10, totalRows: 0},

        this.getCustomers()
        this.setSimulatedCustomer()
      }

      // if(this.isHomePageRequest){
      //   this.isHomePageRequestData=true
      //   if (this.brand  && this.brand.id && this.brand.name ){
      //     this.selectedBrand=this.brand.id
      //     this.selectedBrandName=this.brand.name
      //   }

      //   if(this.filter ){
      //     this.reference = this.filter
      //   }

      // }
      this.getAllBrands()
      this.getGroups();
      //this.getManufacturers()
      this.getSimulatedCustomer();

      this.getVinSubGroups();

      this.getClaimTypes();
  },
     data () {
        return {
          role:null,
          privileges:"",
          isAdmin:false,
          customerOutstandingInfo:{inProgressStr: null, ceilingStr:null},
          isGettingCustomerOutstandingInfo: false,
          currentYear:null,
          itemsListFields: [
            // { key:"show_similair", label: "", sortable: false, tdClass:"font-weight-bold align-middle ", thClass:"text-primary ", thStyle:"width:50px;"},
            { key:"ref", thClass:"text-left", tdClass:"text-left font-weight-bold align-middle", },
            { key:"title", thClass:"text-left ", tdClass:"text-left align-middle", thStyle:"width:300px;"},
            // { key:"position",thClass:"text-left ", tdClass:"text-left align-middle "},
            { key:"brand",thClass:"text-left", tdClass:"text-left font-weight-bold align-middle"},
            { key:"price", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            // { key:"discountStr",thClass:"text-center d-md-table-cell d-none", tdClass:"text-center align-middle font-weight-bold d-md-table-cell d-none"},
            // { key:"discountedPrice", thClass:"text-right d-md-table-cell d-none", tdClass:"text-right d-md-table-cell d-none align-middle"},
            { key:"stockStatus",thClass:"text-center", tdClass:"text-center align-middle"},
            // { key:"modal",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"salesUnit", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            { key:"claim", thClass:"text-center", tdClass:"text-center font-weight-bold align-middle"},
            { key:"info", thClass:"text-center", tdClass:"text-center font-weight-bold align-middle"},
            { key:"action", label:"", thStyle:"width:111px;", tdClass:"align-middle"},
            ],
          similairItemsFields:[
            { key:"ref", thClass:"text-left", tdClass:"text-left font-weight-bold align-middle"},
            { key:"title", thClass:"text-left", tdClass:"text-left align-middle"},
            // { key:"position",thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"brand",thClass:"text-left", tdClass:"text-left font-weight-bold align-middle"},
            { key:"price", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            // { key:"discountStr",thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none font-weight-bold align-middle"},
            // { key:"discountedPrice", thClass:"text-right d-md-table-cell d-none", tdClass:"text-right d-md-table-cell d-none align-middle"},
            { key:"stockStatus",thClass:"text-center", tdClass:"text-center align-middle"},
            // { key:"modal",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"salesUnit", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            { key:"claim", thClass:"text-center", tdClass:"text-center font-weight-bold align-middle"},
            { key:"info", thClass:"text-center", tdClass:"text-center font-weight-bold align-middle"},
            { key:"action", label:"", tdClass:"align-middle float-lg-right"},
            ],

            ordersListFields: [
            { key:"submissionDate", label: "Date d'ajout", tdClass:"align-middle font-weight-bold"},
            { key:"extId", label: "Nº BC",thClass:"",tdClass:"align-middle" },
            { key:"submissionUserName", label: "Vendeur",   thClass:" ", tdClass:" align-middle"},
            { key:"total", label:"Total HT",thClass:"text-right d-md-table-cell d-none" , tdClass: "text-right d-md-table-cell align-middle d-none"},
            { key:"isPartial", label: "isPartial",  thClass:"text-right ", tdClass:"align-middle text-right"},
            { key:"status", label: "Etat de livraison",thClass:"text-right" ,tdClass:"text-right align-middle"},
            // { key:"deliveryStatus", label: "Etat de livraison",   thClass:"text-right ", tdClass:"text-right align-middle"},
            // { key:"billingStatus", label: "Etat de crédit",thClass:"text-right d-md-table-cell d-none" ,tdClass:"text-right align-middle d-md-table-cell d-none"},
            { key:"actions", label:"",tdClass:"text-center align-middle"},
            ],

          itemsList:[],
          isTableLoading:false,
          isItemsTableBusy:false,
          pagemodel: {currentPage : 1, perPage : 3, totalRows: 0},
          showDetailsModal:false,
          selectedItem:null,
          filesList:[{id:1,name:"description"},{id:2,name:"fiche technique"}],
          itemsFilter:null,
          
          selectedBrandName:null,
          brandsList:[],
          selectedBrand:null,

          groupsList: [],
          selectedGroup: null,

          subGroupsList: [],
          selectedSubGroup: null,

          manufacturersList:[],
          selectedManufacturer:null,
          vehiculeModelList:[],
          selectedVehiculeModel:null,
          motorizationTypeList:[],
          selectedMotorizationType:null,
          oemFilter:null,
          competitorsList:[],
          selectedCompetitor:null,
          selectedCompetitorReference:null,
          orderLines: [],
          order: {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0},          
          orderFields: [
            { key:"itemTitle", sortable: true, tdClass:"p-0"},
            { key:"quantity", sortable: false, tdClass:"text-right", thClass:"text-right", thStyle:"width:65px"},
            { key:"price", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
          ],
          draftFields: [
            {key:"actions", label:""},
            { key:"ref", sortable: false, tdClass:"pt-2"},
            { key:"submissionUserName", sortable: false, tdClass:"pt-2"},
            { key:"date", sortable: true, tdClass:"text-right pt-2", thClass:"text-right"},
          ],
          draftLines:[],
          draftsPagination: {currentPage : 1, perPage : 10, totalRows: 0},
          isDraftsTableLoading: false,
          showOrdersDetailsModal:false,
          selectedPriority: { value: 1, name: 'Normale : livraison J+1' },
          optionsPriorities: [
            { value: 0, name: 'Basse : veuillez selectionner la date de livraison souhaitée' },
            { value: 1, name: "Normale : livraison J+1" },
            { value: 2, name: "Urgente: livraison le jour même"  },
          ],
          orderMessage: '',
          isAddToOrderStarting:false,
          oemReference:null,
          reference:null,
          showHistoryModal:false,
          desiredDeliveryDate:null,
          selectedItemOEMsList:[],
          isGettingOemsStarting:false,
          selectedItemManufacturersList:[],
          isGettingItemsManufacturersStarting:false,
          vin:null,
          isCheckingOrder:false,
          promotionCode:null,

          isSimilairItemsTableBusy:false,
          similairItemsList:[],
          similairItemsPagemodel: {currentPage : 1, perPage : 250, totalRows: 0},

          isKitItemsTableBusy:false,
          kitItemsList:[],
          kitItemsPagemodel: {currentPage : 1, perPage : 250, totalRows: 0},

          showcard:false,
          cardItem:null,
          selectedDeliveryAddress: null,
          isHomePageRequestData:false,
          isPricesTableLoading:false,
          pricesList:[],
          pricesListFields:[
            { key:"sageId", thClass:"text-left", tdClass:"text-left" },
            { key:"code", thClass:"text-left", tdClass:"text-left" },
            { key:"startDate", thClass:"text-left", tdClass:"text-left" },
            { key:"endDate", thClass:"text-left", tdClass:"text-left" },
            { key:"index", thClass:"text-left", tdClass:"text-left" },
            { key:"priority", thClass:"text-left", tdClass:"text-left" },
            { key:"type", thClass:"text-left", tdClass:"text-left" },
            { key:"export", label:"", thClass:"text-right", tdClass:"text-right" },
          ],
          pricesPagemodel:{currentPage : 1, perPage : 10, totalRows: 0},
          exportPricesInProgress:false,
          customersList:[],
          selectedCustomer:null,

          vinDetails: {},
          selectedVin: null,
          vinSubGroupsList: [],
          selectedVinSubGroup: null,
          selectedVinBrand: null,
          isReferenceSearchActif: true,

          ordersByItemList: [],
          pagemodelOrdersByItem: {currentPage : 1, perPage : 5, totalRows: 0},
          isOrdersByItemTableLoading: null,

          showViewOldOrderModal:false,
          viewOldOrderId:null,

          paginationOptions:[10,15,50,100],

          kitComponents: [],
          kitComponentsVisible: false,


          showQuantityModal: false,
          quantityInfo: {},

          showAddClaimModal: false,
          selectedClaimType: null,
          optionsClaimType: [],
          claimMessage: null,

          showAttributesModal: false,
          itemAttributes: [],

          highlightsList: [],
          selectedPromotion: null,

          itemsListTimestamp: null, 

          arl: null,


          showClaimModal: false,
          claimReference: null,

          claimForm: {
            refType: 0,
            brand: null
          },
          claimFormKey:0,
          warningMessage: null

        };
     },
  methods:{

    setRefType(type){
      this.claimForm.refType = type
      this.claimFormKey++
    },

    getHighlights(){
      
        AnnouncementsApi.getHighlights(1, 50)
            .then(result => {
              if(result){
                this.highlightsList=result.list.filter(item => item.tagEn !== null && item.tagEn !== '');

                for (var i=0; i< this.highlightsList.length; i++) {
                  if (this.highlightsList[i].id == this.promotionId) {
                   this.selectedPromotion = this.highlightsList[i];
                  }
                }

              }
            })
        },

   

    findItemsByReference() {
        this.isTableLoading = true;
        this.itemsListTimestamp = new Date().getTime();
        ItemsApi.findItems(this.pagemodel.currentPage, this.pagemodel.perPage, this.selectedBrand == null ? null : this.selectedBrand.id, this.reference, this.selectedGroup == null ? null : this.selectedGroup.id, this.selectedSubGroup == null ? null : this.selectedSubGroup.id, 
              this.selectedPromotion != null ? this.selectedPromotion.id : null,
              this.itemsListTimestamp)
        .then(itemsList => {
          if(itemsList){

            if (itemsList.requestTimestamp && itemsList.requestTimestamp != this.itemsListTimestamp) {
              console.log('old request ignored')
              return;
            }

          this.arl = itemsList.arl;

          this.itemsList = itemsList.list
          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.itemsList.forEach(function(item){
              item.quantity = item.multiple > 1 ? item.multiple : 1;
          });   
          
          this.similairItemsList = [];
          this.kitItemsList = [];
          this.kitComponents = [];
          
          }
        })
        .finally(() => {
        this.isTableLoading = false;

      })

      },
    findItemsByOEM() {
        this.isTableLoading = true;
        ItemsApi.findItemsByOEM(this.pagemodel.currentPage, this.pagemodel.perPage,this.selectedBrand,this.oemReference)
        .then(itemsList => {
          if(itemsList){

          this.arl = itemsList.arl;

          this.itemsList = itemsList.list
          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.itemsList.forEach(function(item){
              item.quantity = item.multiple > 1 ? item.multiple : 1;
          });   
          
          this.similairItemsList = [];
          this.kitItemsList = [];
          this.kitComponents = [];
          
          }
        })
        .finally(() => {
        this.isTableLoading = false;
        this.isHomePageRequestData=false

      })

      },

     statusToColor(status) {
      switch(status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'info';
        case 3: return 'success';
        case 4: return 'secondary';
        default: return 'black';
      }
    },

     statusToLabel(status) {
      switch(status) {
        case 0: return 'draft';
        case 1: return 'new';
        case 2: return 'confirmed';
        case 3: return 'delivered';
        case 4: return 'canceled';
        default: return '_';
      }
    },

    findItemsByVehicules() {
        this.isTableLoading = true;
        ItemsApi.findItemsByVehicules(this.pagemodel.currentPage, this.pagemodel.perPage,this.selectedBrand,
        this.selectedManufacturer==null ? null : this.selectedManufacturer.id ,
        this.selectedVehiculeModel==null ? null : this.selectedVehiculeModel.id ,
        this.selectedMotorizationType==null ? null : this.selectedMotorizationType.id)
        .then(itemsList => {
          if(itemsList){

          this.arl = itemsList.arl;

          this.itemsList = itemsList.list
          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.itemsList.forEach(function(item){
              item.quantity = item.multiple > 1 ? item.multiple : 1;
          });   
          
          this.similairItemsList = [];
          this.kitItemsList = [];
          this.kitComponents = [];

          }
        })
        .finally(() => {
        this.isTableLoading = false;
        this.isHomePageRequestData=false

      })

      },

    findItemsByVIN(){

      if (!this.selectedVin || !this.selectedVinSubGroup) {
        return;
      }

        this.isTableLoading = true;
        ItemsApi.findItemsByVIN(this.pagemodel.currentPage, this.pagemodel.perPage,this.selectedVinBrand == null ? null : this.selectedVinBrand.id, this.selectedVinSubGroup.partsGwId,this.selectedVin)
        .then(itemsList => {
          if(itemsList){

          this.arl = itemsList.arl;
            
          this.itemsList = itemsList.list
          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.itemsList.forEach(function(item){
              item.quantity = item.multiple > 1 ? item.multiple : 1;
          });
          
          this.similairItemsList = [];
          this.kitItemsList = [];
          this.kitComponents = [];
          
          this.itemsList.sort(function(itemA, itemB) {
              return itemA.stockStatus - itemB.stockStatus;
            });
          
          }
        })
        .finally(() => {
        this.isTableLoading = false;
        this.isHomePageRequestData=false

      })

    },

    findItems(){


      if(this.role == 1){
        if (!this.selectedCustomer) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          Swal.fire({
            icon: "warning",
            title: "Client requis",
            text: "Vous devez selectionner un client avant de rechercher un article.",
            confirmButtonText: "OK"
          });

          return
        }

      }

      if (!this.selectedVin) {
          this.findItemsByReference();
      } else {

        this.findItemsByVIN();
      }

      

      // if(this.oemReference!=null && this.oemReference!=''){
      //   this.findItemsByOEM()
      // }else if(this.selectedManufacturer!=null){
      //   this.findItemsByVehicules()
      // }else if(this.vin!=null && this.vin!=''){
      //   this.findItemsByVIN()
      // }else{
      //   this.findItemsByReference()
      // }


      // if(this.oemReference!=null && this.oemReference!=''){
      //   this.findItemsByOEM()
      // }else{
      //   if(this.selectedManufacturer!=null){
      //     this.findItemsByVehicules()
      //   }else{
      //     this.findItemsByReference()
      //   }
      // }
    },

    findVinDetails(){

      this.vinDetails = {};
      this.itemsList = [];
      this.pagemodel.totalRows = 0;
      this.pagemodel.currentPage = 1;

      if(!this.selectedVin) {
        return;
      }

      ItemsApi.findVinDetails(this.selectedVin).then(
        (result)=>{
          if (!result) {
            this.vinDetails = {};
          } else {
            
            this.vinDetails=result;
          }
          
        }
      )
    },

    getVinSubGroups() {
        ItemsApi.getVinSubGroups().then(
        (result)=>{
          this.vinSubGroupsList=result;
        }
      )
    },

    getOutstandingInfo(){

      this.isGettingCustomerOutstandingInfo=true
      CustomersApi.getOutstandingInfo().then(
        result =>{
            this.isGettingCustomerOutstandingInfo=false;          
            this.customerOutstandingInfo=result;            
        }
      ).finally(()=>{
        this.isGettingCustomerOutstandingInfo=false;
      })

    },

    getGroups(){
      ItemsApi.getGroups().then(
        (result)=>{
          this.groupsList=result;
        }
      )
    },

    getSubGroups(){
      
      if (this.selectedGroup == null) {
        return;
      }

      ItemsApi.getSubGroups(this.selectedGroup).then(
        (result)=>{
          this.subGroupsList=result;
        }
      )
    },
    
    getManufacturers(){
      ItemsApi.getManufacturers().then(
        (result)=>{
          this.manufacturersList=result
        }
      )
    },

    getModels(){
      ItemsApi.getModels(this.selectedManufacturer==null ? null : this.selectedManufacturer.id).then(
        (result)=>{
          this.vehiculeModelList=result
        }
      )
    },

    getVehicules(){
      ItemsApi.getVehicules(this.selectedVehiculeModel==null ? null : this.selectedVehiculeModel.id).then(
        (result)=>{
          this.motorizationTypeList=result
        }
      )
    },

    getCurrentYear(){
        var dt = new Date();
        this.currentYear  = dt.getFullYear();
    },

    getAllBrands(){
        ItemsApi.getAllBrands().then(
            result => {
                this.brandsList=result;
            }
        )
    },

    checkOrder(){
      this.isCheckingOrder=true
      OrdersApi.checkOrder(this.order.id, this.orderMessage, 
      this.selectedPriority==null ? null : this.selectedPriority.value, 
      this.selectedDeliveryAddress==null ? null : this.selectedDeliveryAddress.id,
      false,this.desiredDeliveryDate,this.promotionCode).then(
        (result)=>{
          if(result){
            this.warningMessage = result.warningMessage
            this.showOrdersDetailsModal = result.isValid
          }
        }
      ).finally(
        ()=>{
          this.isCheckingOrder=false
        }
      )
      
    },

    validateDetails(){
      this.showOrdersDetailsModal=false;  
    },

    addToOrder(data) {
      // The input is in pieces and steps by the item's multiple, but /line/add counts packs:
      // the server multiplies the posted quantity by the multiple. So check and convert here.
      const multiple = data.multiple > 1 ? data.multiple : 1
      if (multiple > 1 && Number(data.quantity) % multiple !== 0) {
        this.$snotify.error(this.$t('catalog.invalidMultiple', { multiple: multiple }))
        return
      }
      const quantity = multiple > 1 ? Number(data.quantity) / multiple : data.quantity

      this.$refs['orderLines-tab'].activate()
      this.isAddToOrderStarting=true
      // if(!data.isQuantityChanged && data.quantity==0){
      //   data.quantity=1
      //   data.isQuantityChanged=true
      // }
      OrdersApi.addLineToOrder(this.order.id, data.id, quantity,null,false) 
      .then(order => {
        if(order) {
          this.orderLines = order.lines;
          this.order = order; 
        }
        })
        .then(()=>{
          this.isAddToOrderStarting=false
        }).finally(()=>{
          this.isAddToOrderStarting=false
        })
    },

    editOrderLine(item){
      OrdersApi.editLineToOrder(this.order.id, item.itemId, item.editedQuantity, this.selectedSupplier, this.selectedPromotion,false) 
      .then(order => {
        if(order) {
          this.orderLines = order.lines;
          this.order = order; 
        }
      })
      .finally(() => {
        item.isOrderQuantityEdit = false

      }) 

      
    },

    removeOrderLine(item){

        Swal.fire({
        title: i18n.t('order.alerts.delete.title'),
        html: item.itemTitle,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.delete.cancelButtonText'),
        confirmButtonText:  i18n.t('order.alerts.delete.confirmButtonText')
      }).then(result => {
        if (result.value) {
          OrdersApi.removeOrderLine(this.order.id, item.itemId,this.selectedSupplier,false)
          .then(order => {
            if (!order) {
              this.clearAll()
            } else {
              this.orderLines = order.lines;
              this.order = order;
            }
          })
        }
      });
    },


    getOrderLines(draft){
      this.$refs['orderLines-tab'].activate();
      OrdersApi.getOrderLines(draft.id).then(
        order => {
          if (order){
            this.orderLines=order.lines
            this.order=order
          }

        }
      )

  },

    cancelOrder(){
        Swal.fire({
        title: i18n.t('order.alerts.deleteDraft.title'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.deleteDraft.cancelButtonText'),
        confirmButtonText: i18n.t('order.alerts.deleteDraft.confirmButtonText'),
      }).then(result => {
        if(result.value){
          OrdersApi.removeDraft(this.order).then(
            isRemoved => {
              if (isRemoved) {
                  this.clearAll();
              }
            }
          )
        }
      })
    },

    getDrafts(){
      this.isDraftsTableLoading=true
      OrdersApi.getOrdersByCustomer(this.draftsPagination.currentPage, this.draftsPagination.perPage,null, true,0,this.isCurrent,null,null)
      .then(drafts => {
        if(drafts){
        this.draftLines = drafts.list
        this.draftsPagination.totalRows = drafts.total;
        this.draftsPagination.currentPage = drafts.page;
        this.draftsPagination.perPage = drafts.pageSize;
        this.draftsPagination.pageSize = drafts.pageSize;
        }

      })

      .finally(() => {
        this.isDraftsTableLoading=false 
      })
    },
    removeDraft(draft){
        Swal.fire({
        title: i18n.t('order.alerts.deleteDraft.title'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.deleteDraft.cancelButtonText'),
        confirmButtonText: i18n.t('order.alerts.deleteDraft.confirmButtonText')
      }).then(result => {
        if(result.value){
          OrdersApi.removeDraft(draft).then(
            isRemoved => {
              if (isRemoved) {
                 this.getDrafts()
                 this.clearAll();
              }
            }
          )
        }
      })
    },

    clearAll(){
        this.orderLines=[]
        this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0};

        if (this.role != 0) {

          this.selectedCustomer = null;

          this.selectedBrand = null;
          this.selectedGroup = null;
          this.selectedSubGroup = null;

          this.reference = null;
        }

        
    },

    getItemsOEMs(){
      this.isGettingOemsStarting=true
      ItemsApi.getItemsOEMs(this.selectedItem==null ? null : this.selectedItem.id).then(
        (result)=>{
          this.selectedItemOEMsList=result
        }
      ).finally(
        ()=>{
          this.isGettingOemsStarting=false
        }
      )

    },
    getItemsManufacturers(){
      this.isGettingItemsManufacturersStarting=true;
      this.selectedItemManufacturersList=[]
      ItemsApi.getItemsManufacturers(this.selectedItem==null ? null : this.selectedItem.id).then(
        (result)=>{
          this.selectedItemManufacturersList=result
        }
      ).finally(
        ()=>{
          this.isGettingItemsManufacturersStarting=false
        }
      )
    },

    scrollToCard(){
      var elmnt = document.getElementById("similairItemsCard");
      elmnt.scrollIntoView(true); 
    },

    getSimilairItems(items){
      
      if(items.length == 0) {
        return;
      }

      var item = items[0];

      this.cardItem=item
      this.showcard=true
      //this.scrollToCard()
      this.isSimilairItemsTableBusy=true
      this.isKitItemsTableBusy=true

      this.kitComponentsVisible=false

      ItemsApi.getSimilairItems(this.similairItemsPagemodel.currentPage, this.similairItemsPagemodel.perPage,item==null ? null : item.id).then(
        (result)=>{
          if(result){

            this.arl = result.arl;

            this.similairItemsList = result.list
            this.similairItemsPagemodel.totalRows = result.total;
            this.similairItemsPagemodel.currentPage = result.page;
            this.similairItemsPagemodel.perPage = result.pageSize;
            this.similairItemsPagemodel.pageSize = result.pageSize;
            this.similairItemsList.forEach(function(item){
                item.quantity = item.multiple > 1 ? item.multiple : 1;
            });          
            }

            this.similairItemsList.sort(function(itemA, itemB) {
              return itemA.stockStatus - itemB.stockStatus;
            });

        }
      ).finally(() => {
        this.isSimilairItemsTableBusy = false;

      })

      ItemsApi.getKit (this.similairItemsPagemodel.currentPage, this.similairItemsPagemodel.perPage,item==null ? null : item.id).then(
        (result)=>{
          if(result){

            this.arl = result.arl;

            this.kitItemsList = result.list
            this.kitItemsPagemodel.totalRows = result.total;
            this.kitItemsPagemodel.currentPage = result.page;
            this.kitItemsPagemodel.perPage = result.pageSize;
            this.kitItemsPagemodel.pageSize = result.pageSize;
            this.kitItemsList.forEach(function(item){
                item.quantity = item.multiple > 1 ? item.multiple : 1;
            });          
            }

            this.kitItemsList.sort(function(itemA, itemB) {
              return itemA.stockStatus - itemB.stockStatus;
            });

        }
      ).finally(() => {
         this.isKitItemsTableBusy = false;
      })

      

      this.findOrdersByItem(item.ref);
    },

    getKitComponents(item) {

      this.kitComponentsVisible=false;
      this.kitComponents = [];

      this.selectedItem = item;

      ItemsApi.getComponents (item==null ? null : item.id).then(



          (result)=>{

            if(result != null){

              this.kitComponents = result;
              this.kitComponentsVisible=true;
              //this.showDetailsModal=true;          
            }

          }
        ).finally(() => {
          
          if (this.kitComponents.length) {
              this.kitComponentsVisible=true;
            }
        })

    },

    getImportQty(item) {

      this.quantityInfo = [];

      this.selectedItem = item;

      ItemsApi.getImportQty (item==null ? null : item.id).then(



          (result)=>{

            if(result != null){

              this.quantityInfo = result;
              this.showQuantityModal=true;   
            }

          }
        ).finally(() => {
          

        })

    },

    closeOrderModal(){
        this.showOrdersDetailsModal=false
        this.clearAll();
    },

    downloadPaymentConditions(){
      CustomersApi.downloadPaymentConditions()
    },

    resetPagination(){
          this.pagemodel.currentPage = 1;
    },

    findPrices() {
        this.isPricesTableLoading = true;
        PricesApi.getPrices(this.pricesPagemodel.currentPage, this.pricesPagemodel.perPage)
        .then(pricesList => {
          if(pricesList){
            this.pricesList = pricesList.list
            this.pricesPagemodel.totalRows = pricesList.total;
            this.pricesPagemodel.currentPage = pricesList.page;
            this.pricesPagemodel.perPage = pricesList.pageSize;
            this.pricesPagemodel.pageSize = pricesList.pageSize;
            this.isPricesTableLoading = false;         
          }
        })
        .finally(() => {
          this.isPricesTableLoading = false;

      })

    },

    exportCSV(priceId){
        this.exportPricesInProgress = true;
      PricesApi.exportCSV(priceId)
       .then(() => {
           this.exportPricesInProgress = false;
        })
    },

    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
          response => {
          this.customersList=response;
          }
      )
    },

    setSimulatedCustomer(){
      UsersApi.setSimulatedCustomer(this.selectedCustomer == null ? null : this.selectedCustomer.id).then(
        (result)=>{

          if(result){
            this.resetVariables()
            if(this.selectedCustomer!=null){
              this.findItems()
            }

            this.getOutstandingInfo();
            this.getAllBrands()
          } else {

            this.clearAll();
          }
        }
      )
    },

    getSimulatedCustomer(){
      UsersApi.getSimulatedCustomer().then(
        (result)=>{
          if(result){
            this.selectedCustomer=result
          }
        }
      )
    },

    resetVariables(){
          this.orderLines= []
          this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0}          
          this.draftLines=[]
          this.draftsPagination= {currentPage : 1, perPage : 10, totalRows: 0}
          this.isDraftsTableLoading= false
          this.showOrdersDetailsModal=false
          this.orderMessage= ''
          this.isAddToOrderStarting=false
          this.desiredDeliveryDate=null
          this.isCheckingOrder=false
          this.promotionCode=null
          this.selectedDeliveryAddress =null
          this.$refs['orderLines-tab'].activate();
    },

    findOrdersByItem(itemRef) {

      this.isOrdersByItemTableLoading = true

      OrdersApi.findOrdersByItem(this.pagemodelOrdersByItem.currentPage, this.pagemodelOrdersByItem.perPage, itemRef)
      .then(orders => {
        if(orders){
          this.ordersByItemList = orders.list
          this.pagemodelOrdersByItem.totalRows = orders.total;
          this.pagemodelOrdersByItem.currentPage = orders.page;
          this.pagemodelOrdersByItem.perPage = orders.pageSize;
          this.pagemodelOrdersByItem.pageSize = orders.pageSize;

        }

      })

      .finally(() => {
        this.isOrdersByItemTableLoading=false 
      })

    },

    addClaim(item) {

      this.selectedClaimType = null;
      this.claimMessage = '';

      this.selectedItem = item;
      this.showAddClaimModal=true; 
    },

    getClaimTypes() {
      ItemsApi.getClaimTypes()
      .then(claimTypes => {
        
          this.optionsClaimType = claimTypes;
      })
    },

    submitClaimInvalidItem() {

      if (!this.claimReference) {
        return
      }

      if (this.claimForm == null || this.claimForm.refType == null) {
        this.$snotify.error('Veuillez choisir le type de réclamation');
        return;
      }

      ItemsApi.submitClaim(null, null, this.claimReference, null, this.claimForm.brand ? this.claimForm.brand.id : null , this.claimForm.refType)
      .then(() => {
          this.showClaimModal = false;
      })
    },

    submitClaim(itemId, itemRef) {

      if (!this.selectedClaimType) {
        return
      }

      if (!itemRef) {
         return
      }

      ItemsApi.submitClaim(this.selectedClaimType.id, itemId, itemRef, this.claimMessage ? this.claimMessage : '')
      .then(() => {
          this.showAddClaimModal = false;
      })
    },

    showItemAttributes(item) {

        if(!item) {
          return;
        }

        this.selectedItem = item;

        this.showAttributesModal = false;
        this.itemAttributes = [];

        ItemsApi.getAttributes(item.id)
          .then(attributes => {
            
              this.showAttributesModal = true;
              this.itemAttributes = attributes;
          })

    },

    openClaimModal(reference) {
      this.claimReference = reference;

      this.claimForm = {
        type: null,
        brand: null
      };

      this.showClaimModal = true;
    },


  },
  watch :{

    // selectedManufacturer: function(){
    //   this.vehiculeModelList=[]
    //   this.selectedVehiculeModel=null
    //   this.motorizationTypeList=[]
    //   this.selectedMotorizationType=null
    //   if(this.selectedManufacturer!=null){
    //     this.getModels()
    //     this.resetPagination();
    //     this.findItemsByVehicules()
    //   }else{
    //     this.resetPagination();
    //     this.findItems()
    //   }

    // },
    

    // selectedVinSubGroup: function() {

    //   this.resetPagination();
    //   this.findItemsByVIN();
    // },

    selectedBrand: function() {

        this.resetPagination();
        this.findItems();
    },

    selectedGroup: function() {

        this.subGroupsList = [];
        this.selectedSubGroup = null;

        //this.resetPagination();
        //this.findItems();

        if (this.selectedGroup != null) {
          this.getSubGroups();
        }

    },

    selectedSubGroup: function() {

        this.resetPagination();
        this.findItems();
    },

    selectedPromotion: function() {

    this.resetPagination();
    this.findItems();
    },

    // promotionId: function() {
    //   console.log(this.promotionId)
    // },

    // selectedVehiculeModel: function(){
    //   this.motorizationTypeList=[]
    //   this.selectedMotorizationType=null
    //   if(this.selectedManufacturer!=null ){
    //     if(this.selectedVehiculeModel!=null){
    //       this.getVehicules()
    //     }
    //     this.resetPagination();
    //     this.findItemsByVehicules()
    //   }
    // },

    // selectedMotorizationType:function(){
    //   if(this.selectedManufacturer!=null && this.selectedVehiculeModel!=null ){
    //     this.resetPagination();
    //     this.findItemsByVehicules();
    //   }
    // },

    // 'filter':function(){
    //     this.reference = this.filter
    //     this.findItems()
    // },

    selectedCustomer:function(){
      this.setSimulatedCustomer()
    }
  }
};

</script>

<style>
    .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

    .vs--single-selectedcustomer .vs__selected {
      color: #d90100;
      /*font-weight:bold;*/
      /*font-size: 16px;*/
    }

    .style-vselect-selectedcustomer .vs__search::placeholder,
    .style-vselect-selectedcustomer .vs__dropdown-toggle,
    .style-vselect-selectedcustomer .vs__search,
    .style-vselect-selectedcustomer .vs__dropdown-menu {
      line-height: 1;
      font-size: 1em;
      background: white;
    }

    .style-vselect-selectedcustomer .vs__clear,
    .style-vselect-selectedcustomer .vs__open-indicator {
      fill: #d90100;
    }

    #admin .nav-tabs-custom  {
      border-bottom:  2px solid #f6f6f6;
    }

    #notAdmin .nav-tabs-custom  {
    border-bottom:  2px solid #ffffff;
    }

    .advanced-vin-search {
      border-bottom: 1px solid #ced4da;
      /*border-right: 1px solid #ced4da;
      border-left: 1px solid #ced4da;*/
      background-color: #f8f8fb;
    } 

    .custom-alert-bg {
      background-color: #ffc1076b !important;
      color: #604904; 
    }

</style>

<template>
<Layout>
  <div>
   
    
    <!-- ------------------ -->
    <!-- CUSTOMER SELECTION -->
    <div class="row pt-4 d-print-none"  />        





    <div v-if="role==1" class="d-print-none px-4">
      <div class="simulation-container">
        <div class="row w-100 align-items-center no-gutters">

          <!-- Selection -->
          <div class="col-lg-4 col-md-5 col-12 pr-2">
            <div class="selection-side">
              <div class="selection-header">
                <i class="mdi mdi-eye text-primary"></i>
                <span>{{$t("catalog.simulatedCustomer.label")}}</span>
              </div>

              <v-select
                class="style-vselect-integrated"
                :options="customersList"
                :placeholder="$t('catalog.simulatedCustomer.placeholder')"
                label="fullCompanyName"
                v-model="selectedCustomer"
              >
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
              </v-select>
            </div>
          </div>

          <!-- Info Side -->
          <div class="col-lg-8 col-md-7 col-12 mt-3 mt-md-0 pl-2">
            <div v-if="selectedCustomer" class="info-side">
              <div class="customer-details-row">
                
                <!-- Identity Section -->
                <div class="customer-identity">
                  <h6 class="company-name" v-b-tooltip.hover :title="selectedCustomer.companyName">
                    <i class="mdi mdi-account-tie mr-1"></i>
                    <span class="company-name-text">{{ selectedCustomer.companyName }}</span>
                  </h6>
                  <span class="customer-code">Code: {{ selectedCustomer.code }}</span>
                </div>

                <!-- Details Section -->
                <div class="details-grid">
                  <div class="detail-item" v-b-tooltip.hover :title="selectedCustomer.address || '-'">
                    <i class="mdi mdi-map-marker text-danger"></i>
                    <span class="detail-value" >{{ selectedCustomer.address || '-' }}</span>
                  </div>

                  <div class="detail-item" v-b-tooltip.hover :title="selectedCustomer.phone || '-'">
                    <i class="mdi mdi-phone text-success"></i>
                    <span class="detail-value">{{ selectedCustomer.phone || '-' }}</span>
                  </div>

                  <div class="detail-item" v-b-tooltip.hover :title="selectedCustomer.mail || '-'">
                    <i class="mdi mdi-email text-info"></i>
                    <span class="detail-value">{{ selectedCustomer.mail || '-' }}</span>
                  </div>

                  <div class="detail-item" v-b-tooltip.hover :title="selectedCustomer.defaultDeliveryMode || '-'">
                    <i class="mdi mdi-truck-fast text-warning"></i>
                    <span class="detail-value">{{ selectedCustomer.defaultDeliveryMode || '-' }}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>




    <!-- CUSTOMER SELECTION -->
    <!-- ------------------ -->

      <div class="row">
          <div class="col-12  pr-4 pl-4 pb-2 ">
              <GroupSparkLine class="mt-md-1 mt-0 p-md-0 mb-1" :totalsData="customerOutstandingInfo"/>
          </div>
      </div>
    


    <div class="row pl-4  d-print-none">
      
      
      <!-- FIRST COLUMN OF PAGE -->
      <div  class ="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 pr-4">
        <div class="card h-100">
          <div class="card-body card bg-Default">

            <!-- Catalog Title -->
            <h4 class="card-title text-warning text-uppercase">{{$t("catalog.title")}}</h4>
            <p class="card-title-desc d-none d-sm-block">
              Recherche des pièces par réf et désignation avec les listes d'Equivalences et Kits.
            </p>


  


            <b-tabs  content-class="p-3 text-muted advanced-vin-search" >
              <b-tab @click="pagemodel={currentPage : 1, perPage : 10, totalRows: 0};isReferenceSearchActif = true;selectedVin = null;" lazy >
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-search font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-search font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Filtres</span>
                  </template>

                  <!-- Promotions Search Filter -->
                  <div v-if="highlightsList.length" class="row pl-4 mt-sm-0 pt-3 pr-4">

                      <div class="col-sm-12 col-xs-12">
                          <v-select   class="style-vselect style-vselect-selectedcustomer vs--single-selectedcustomer font-size-14 text-muted" placeholder="Filtrer par Promotion" :options="highlightsList" v-model="selectedPromotion" label="title">
                              <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                          </v-select> 
                      </div>
                  </div>

                  <!-- Advanced Search Filter -->
                  <div class="row pl-4 mt-sm-0 pt-3 pr-4">
                      <div class="col-sm-4 col-xs-12">
                          <v-select class="style-vselect style-vselect-selectedcustomer vs--single-selectedcustomer font-size-14 text-muted" placeholder="Marque" :options="brandsList" v-model="selectedBrand" label="name">
                              <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                          </v-select> 


                          <!-- <v-select class="style-vselect pb-2  font-size-16"   :options="manufacturersList" v-model="selectedManufacturer" :placeholder="$t('searchFilters.vehicleSearch.placeholders.constructor')" label="name" :disabled="(reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (vin!=null && vin!='')" >
                                <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                            </v-select> -->


                      </div>

                      <div class="col-sm-4 col-xs-12 mt-sm-0 mt-2 pl-sm-2">
                          <v-select class="style-vselect style-vselect-selectedcustomer vs--single-selectedcustomer font-size-14" placeholder="Groupe" :options="groupsList" v-model="selectedGroup"  label="name">
                              <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                          </v-select> 
                      </div>

                      <div class="col-sm-4 col-xs-12 mt-sm-0 mt-2 pl-sm-2">
                          <v-select class="style-vselect style-vselect-selectedcustomer vs--single-selectedcustomer font-size-14" placeholder="Sous Groupe" :options="subGroupsList" v-model="selectedSubGroup" label="name">
                              <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                          </v-select> 
                      </div>
                  </div>

                  <!-- Main Search Filter -->
                  <div class="row pb-3 pl-4 pr-4 pt-sm-2 mt-2 pt-3">
                    <div class="col-12">
                      <b-input-group>
                        <b-form-input v-model="reference" :placeholder="$t('searchFilters.referenceSearch.reference.placeholder')" @keyup.native.enter="resetPagination();findItems();" :disabled="(oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) ||  (vin!=null && vin!='')" 
                        :style="(oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) || (vin!=null && vin!='') ? 'background-color:#f2f2f2;' : ''" ></b-form-input>
                        <template v-slot:append>
                            <b-button  size="sm" variant="warning" @click="resetPagination();findItems();">
                            <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                            </b-button>
                        </template>                            
                      </b-input-group>
                    </div>
                  </div>
                        
                      
                </b-tab>
                <b-tab @click="isReferenceSearchActif = false; findVinDetails();findItemsByVIN();" lazy>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-credit-card font-size-16"></i>
                      </span>
                      <i class="d-none d-sm-inline-block far fa-credit-card font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">VIN</span>
                    </template>

                   

                    
                     <div class="row pl-4 mt-sm-0 pb-1 pr-4 pt-2">

                        

                       <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 pr-lg-2 pr-sm-0 pr-xs-0 pt-2">

                         <!-- <b-input-group> -->
                            <b-form-input v-model="selectedVin" class="font-weight-bold text-uppercase text-warning" placeholder="Numéro de Chassis" @keyup.native.enter="findVinDetails();findItemsByVIN();"> 
                            </b-form-input>
                            <!-- <template v-slot:append>
                                <b-button  size="sm" variant="warning" @click="findVinDetails();">
                                <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                                </b-button>
                            </template>                             -->
                          <!-- </b-input-group> -->

                       </div>

                       <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-right pr-lg-2 pl-lg-2 pr-sm-0 pl-sm-0 pl-xs-0 pt-2">

                          <v-select class="style-vselect style-vselect-selectedcustomer vs--single-selectedcustomer font-size-16" placeholder="Sous Groupe" :options="vinSubGroupsList" v-model="selectedVinSubGroup" label="name">
                                <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                            </v-select> 

                       </div>

                      


                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-right pl-lg-2 pl-sm-0 pl-xs-0 pt-2">
                               <b-button variant="warning" style="width: 100%"  @click="findVinDetails();findItemsByVIN();" >
                                  <i class="bx bx-search-alt font-size-16 font-weight-bold  align-middle mr-2"></i> <span class="font-weight-bold">Chercher</span>
                              </b-button>
                        </div>



                      
                     </div>

                      <div class="row pl-4 mt-sm-0 pt-1 pb-3 pr-4">

                      <div class="col-12 text-left">

                          <v-select class="style-vselect style-vselect-selectedcustomer vs--single-selectedcustomer font-size-14 text-muted" placeholder="Marque" :options="brandsList" v-model="selectedVinBrand" label="name">
                              <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                          </v-select> 

                        </div>
                      
                      </div>


                     <div class="row pl-4 mt-sm-0 pr-4">

                       <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 text-left pr-1 pl-1 pt-3">
                          <i class="fas fa-car font-size-14 text-primary font-weight-bold pr-2"/><span class="text-primary font-weight-bold font-size-14">Marque et Modèle</span>
                          <br/><span class="text-primary font-size-14">{{vinDetails.manufacturer ? vinDetails.manufacturer : '-'}} {{vinDetails.model ? vinDetails.model : ''}}</span>
                       </div>

                       <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 text-left pr-1 pl-1 pt-3">
                          <i class="mdi mdi-car-info font-size-18 text-primary font-weight-bold pr-2"/><span class="text-primary font-weight-bold font-size-14">Type</span>
                          <br/><span class="text-primary font-size-14">{{vinDetails.type ? vinDetails.type : '-'}}</span>
                       </div>

                       <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 text-left pr-1 pl-1 pt-3">
                          <i class="mdi mdi-train-car font-size-18 text-primary font-weight-bold pr-2"/><span class="text-primary font-weight-bold font-size-14">Carosserie</span>
                          <br/><span class="text-primary font-size-14">{{vinDetails.bodyType ? vinDetails.bodyType : '-'}}</span>
                       </div>

                       <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 text-left pr-1 pl-1 pt-3">
                          <i class="fas fa-gas-pump font-size-14 text-primary font-weight-bold pr-2"/><span class="text-primary font-weight-bold font-size-14">Carburant</span>
                          <br/><span class="text-primary font-size-14">{{vinDetails.fuel ? vinDetails.fuel : '-'}}</span>
                       </div>

                     </div>

                     <div class="row pl-4 mt-sm-0 pr-4">

                       <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12  text-left pr-1 pl-1 pt-3">
                          <i class="mdi mdi-car-cruise-control font-size-18 text-primary font-weight-bold pr-2"/><span class="text-primary font-weight-bold font-size-14">Puissance Fiscale</span>
                          <br/><span class="text-primary font-size-14">{{vinDetails.fiscalPower ? vinDetails.fiscalPower : '-'}}</span>
                       </div>

                       <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12  text-left pr-1 pl-1 pt-3">
                          <i class="mdi mdi-engine-outline font-size-18 text-primary font-weight-bold pr-2"/><span class="text-primary font-weight-bold font-size-14">Moteur</span>
                          <br/><span class="text-primary font-size-14">{{vinDetails.engine ? vinDetails.engine : '-'}}</span>
                       </div>

                       <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12  text-left pr-1 pl-1 pt-3">
                          <i class="fas fa-cogs font-size-14 text-primary font-weight-bold pr-2"/><span class="text-primary font-weight-bold font-size-14">Cylindrée</span>
                          <br/><span class="text-primary font-size-14">{{vinDetails.cylinder ? vinDetails.cylinder : '-'}}</span>
                       </div>

                     </div>

                  </b-tab>
              </b-tabs>













            
            

            <div v-if="arl" class="row pt-4">
              <div class="col-12">
                
                <b-alert v-if="arl === 1" v-show="arl" show variant="warning" class="m-0 font-size-14 font-weight-bold custom-alert-bg">
                  <i class="fas fa-exclamation-triangle mr-2"></i> Attention, vous êtes sur le point d’atteindre <strong>la limite autorisée de recherches</strong> sur la plateforme !
                  <div class="font-size-12 font-weight-normal mt-2">Après avoir atteint cette limite, vous ne pourrez plus effectuer de nouvelles recherches.</div>
                </b-alert>
                <b-alert v-if="arl === 2" v-show="arl" show variant="danger" class="m-0 font-size-14">
                  <i class="fas fa-exclamation-triangle mr-2"></i><strong>Limite de recherches atteinte !</strong> 
                  <div class="font-size-12 font-weight-normal mt-2">vous ne pouvez plus effectuer de nouvelles recherches pour le moment.
                    Merci de réessayer ultérieurement pour effectuer de nouvelles recherchess</div>

                </b-alert>


              </div>
            </div>

            <!-- ------------ -->
            <!-- Main Catalog -->
            <div class="row pl-4 pr-4 pt-2">
              <div class="col-12">
                <div class="table-responsive pt-4" style="min-height:20em; /*30em;*/" >        
                  <b-table 
                  hover
                  :busy="isTableLoading"
                  :items="itemsList"
                  :fields="itemsListFields"
                  :perPage="pagemodel.perPage"
                  class="table  "
       
       
       selectable
       select-mode="single"
       selected-variant="info"
       @row-selected="getSimilairItems"


                  
                  >
                  <template v-slot:head(ref)>
                    {{ $t("catalog.header.reference") }} 
                  </template>
                  <template v-slot:head(title)>
                    {{ $t("catalog.header.title") }} 
                  </template>
                  <!-- <template v-slot:head(position)>
                    {{ $t("catalog.header.shockAbsorberPosition") }} 
                  </template> -->
                  <template v-slot:head(brand)>
                    {{ $t("catalog.header.brand") }} 
                  </template>
                  <template v-slot:head(price)>
                    {{ $t("catalog.header.price") }} 
                  </template>
                  <!-- <template v-slot:head(discountStr)>
                    {{ $t("catalog.header.discount") }} 
                  </template> -->
                  <!-- <template v-slot:head(discountedPrice)>
                    {{ $t("catalog.header.discountedPrice") }} 
                  </template> -->
                  <!-- <template v-slot:head(modal)>
                    {{ $t("catalog.header.modal") }} 
                  </template> -->
                  <template v-slot:head(salesUnit)>
                    {{ $t("catalog.header.multiple") }} 
                  </template>

                  <template v-slot:head(stockStatus)>
                    {{ $t("catalog.header.stockStatus") }} 
                  </template>
                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  <!-- <template v-slot:cell(discountStr)="{value}">
                    {{value == 0 || value ==null ? '_' : value+'%'}} 
                  </template> -->
                  <template v-slot:cell(price)="{item,value}">
                    <div :class="item.stockStatus == 2 ? 'text-danger' : item.stockStatus == 3 ? '' : 'text-primary'">{{value ? value : ''}} </div>
                  </template>
                  <!-- <template v-slot:cell(discountedPrice)="{value}">
                    {{value ? value : '_'}} 
                  </template> -->
                  <template v-slot:cell(brand)="{value}">
                    {{value.name}} 
                  </template>

                  <template v-slot:cell(salesUnit)="{item,value}">       
                    <i v-if="item.isQtyInfo" @click="getImportQty(item)" class="fas fas fa-shipping-fast font-size-16 mr-4" style="color: #ffc107 !important; cursor:pointer;"/> {{value}} 
                  </template>

                  <template v-slot:cell(claim)="{item}">
                    <span @click="addClaim(item)" style="cursor:pointer;" ><i class="mdi mdi-comment-text-multiple-outline font-size-18 text-danger" /></span>
                  </template>

                  <template v-slot:cell(info)="{item}">
                    <span v-if="item.hasInfo || item.isKit" @click="showItemAttributes(item)" style="cursor:pointer;" ><i class="fas fa-question-circle font-size-18 text-info" /></span>
                  </template>

                  <template v-slot:head(claim)>
                    Réclamation
                  </template>


                  <template v-slot:cell(ref)="{item, value}">
                    <span>{{value}} <!--i style="vertical-align:middle; cursor:pointer;" class="dripicons-information text-warning font-size-14 ml-1" @click="getKitComponents(item);" v-if="item.isKit"> </i--></span>
                    <br/><span class="text-muted font-weight-normal " v-if="item.isOemEquivalent"><i>OEM: <strong>{{ item.isOemEquivalent }}</strong></i></span>
                  </template>

                  <template  v-slot:cell(action)="{item}">
                    <div  class="input-group    mb-0" style="width: 7em;" :class=" !item.isQtyInfo && (!item.id || item.stockStatus >1 || (role ==1 && selectedCustomer == null)) ? 'd-none' : ''">
                      <b-form-input  type="number" :min="item.multiple > 1 ? item.multiple : 1" :step="item.multiple > 1 ? item.multiple : 1" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                        v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                      <div size="sm" class="input-group-append">
                        <button  type="button"  class="btn input-group-text text-success btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                          <i v-if="!isAddToOrderStarting"  class=" fas fa-plus-circle font-size-14"> </i>
                          <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                        </button>
                      </div>
                    </div>

                  </template>
                  <template  v-slot:cell(stockStatus)="{value}">
                          <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
                          <div v-else-if="value==3"  class="font-size-18"> _</div>
                          <i v-else :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>

                          

                  </template>

                  <!-- <template v-slot:cell(show_similair)="{item}">
                    <span><i :title="$t('catalog.similairItems.title')" class="fab fa-creative-commons-nd font-size-22 text-warning" style="cursor: pointer; " @click="getSimilairItems(item)" ></i></span>
                  </template> -->


                  <!-- <template v-slot:cell(modal)="{item}">
                      <i class="far fa-list-alt font-size-18 text-primary" style="cursor:pointer" @click="showDetailsModal=true;selectedItem=item;getItemsManufacturers();" ></i>
                      
                  </template> -->
                  </b-table>
                  <span v-if="!isTableLoading && !itemsList.length" class="d-flex justify-content-center mt-4 mb-1 text-muted" >{{ $t("catalog.empty") }} </span>
                  
                  
                  <span
                    @click="openClaimModal(reference)"
                    v-if="reference && !isTableLoading && !itemsList.length && !arl"
                    class="d-flex justify-content-center font-size-14 mb-4 mt-2 text-warning font-weight-bold"
                    style="cursor:pointer;"
                  >
                    <i><u>Ajouter une Réclamation ?</u></i>
                    <i class="mdi mdi-comment-text-multiple-outline font-size-14 font-weight-bold text-warning ml-2" />
                  </span>                  

                  

                </div>
                <!-- Pagination -->
                <div class="row pt-3 mb-1 pl-2" v-if="isReferenceSearchActif">
                    <div class="col-sm-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @change="findItems()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="paginationOptions"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                        </div>
                    </div>
                    <div class="col-sm-4" >
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findItems()" :disabled="isTableLoading" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div> 
                <!-- Fin Pagination  -->
              </div>
            </div>
            <!-- End Main Catalog -->
            <!-- ---------------- -->



            <!-- ------------ -->
            <!-- Equivalences -->
            <div class="row d-print-none" v-if="isReferenceSearchActif">
                  <div  class ="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                    <b-card id="similairItemsCard" no-body header-class="bg-transparent border-secondary" class="border border-muted border-2 mb-0 mt-4" > 
                      <div class="row" style="background-color:#eff2f7;">
                        <div class="col-12">
                          <h5 class="card-title mt-2 mb-2 text-warning text-center" >EQUIVALENCES {{cardItem ? "[" + cardItem.ref + "]" : ""}}</h5>
                        </div>
                        <!-- <div class="col-1 text-right ">
                            <i  class=" fas fa-times font-size-16 pr-4 pt-2 pb-2 text-danger" @click="showcard=false" style="cursor:pointer" :title="$t('datPicker.label-close-button')"> </i>
                        </div> -->
                      </div>
                      <div class="table-responsive mb-0">
                        <b-table
                          :striped="true"
                          :small="true"
                          :hover="true"
                          :no-border-collapse="true"
                          :busy="isSimilairItemsTableBusy"
                          :items="similairItemsList"
                          :fields="similairItemsFields"
                          
                        >
                        <template v-slot:head(ref)>
                          {{ $t("catalog.header.reference") }} 
                        </template>
                        <template v-slot:head(title)>
                          {{ $t("catalog.header.title") }} 
                        </template>
                        <!-- <template v-slot:head(position)>
                          {{ $t("catalog.header.shockAbsorberPosition") }} 
                        </template> -->
                        <template v-slot:head(brand)>
                          {{ $t("catalog.header.brand") }} 
                        </template>
                        <template v-slot:head(price)>
                          {{ $t("catalog.header.price") }} 
                        </template>
                        <!-- <template v-slot:head(discountStr)>
                          {{ $t("catalog.header.discount") }} 
                        </template> -->
                        <!-- <template v-slot:head(discountedPrice)>
                          {{ $t("catalog.header.discountedPrice") }} 
                        </template> -->
                        <!-- <template v-slot:head(modal)>
                          {{ $t("catalog.header.modal") }} 
                        </template> -->
                        <template v-slot:head(salesUnit)>
                          {{ $t("catalog.header.multiple") }} 
                        </template>
                        <template v-slot:head(stockStatus)>
                          {{ $t("catalog.header.stockStatus") }} 
                        </template>

                        <template v-slot:cell(salesUnit)="{item,value}">
                          <i v-if="item.isQtyInfo" @click="getImportQty(item)" class="fas fas fa-shipping-fast font-size-16 mr-4" style="color: #ffc107 !important; cursor:pointer;"/> {{value}} 
                        </template>

                        <template v-slot:cell(claim)="{item}">
                          <span @click="addClaim(item)" style="cursor:pointer;"><i class="mdi mdi-comment-text-multiple-outline font-size-18 text-danger" /></span>
                        </template>

                        <template v-slot:cell(info)="{item}">
                          <span v-if="item.hasInfo || item.isKit" @click="showItemAttributes(item)" style="cursor:pointer;"><i class="fas fa-question-circle font-size-18 text-info" /></span>
                        </template>

                        <template v-slot:head(claim)>
                          Réclamation
                        </template>


                        <template v-slot:table-busy>
                          <div class="text-center my-2">
                              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                          </div>
                        </template>
                        <!-- <template v-slot:cell(discountStr)="{value}">
                          {{value == 0 || value ==null ? '_' : value+'%'}} 
                        </template> -->
                        <template v-slot:cell(price)="{item,value}">
                          <div :class="item.stockStatus == 2 ? 'text-danger' : item.stockStatus == 3 ? '' : 'text-primary'">{{value ? value : '_'}} </div>
                        </template>
                        <!-- <template v-slot:cell(discountedPrice)="{value}">
                          {{value ? value : '_'}} 
                        </template> -->
                        <template v-slot:cell(brand)="{value}">
                          {{value.name}} 
                        </template>

                        <template v-slot:cell(ref)="{item, value}">
                          <span>{{value}} <!--i style="vertical-align:middle; cursor:pointer;" class="dripicons-information text-warning font-size-14 ml-1" @click="getKitComponents(item);" v-if="item.isKit"> </i--></span>
                        </template>

                        <template  v-slot:cell(action)="{item}">
                          <div  class="input-group    mb-0" style="width: 7em;"  :class="!item.id || item.stockStatus >1 || (role ==1 && selectedCustomer == null)  ? 'd-none' : ''">
                            <b-form-input  type="number" :min="item.multiple > 1 ? item.multiple : 1" :step="item.multiple > 1 ? item.multiple : 1" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                              v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                            <div size="sm" class="input-group-append">
                              <button  type="button"  class="btn input-group-text text-success btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                                <i v-if="!isAddToOrderStarting"  class=" fas fa-plus-circle font-size-14"> </i>
                                <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                              </button>
                            </div>
                          </div>

                        </template>
                        <template  v-slot:cell(stockStatus)="{value}">
                            <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
                            <div v-else-if="value==3"  class="font-size-18"> _</div>
                            <i v-else :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
                        </template>
                        <!-- <template v-slot:cell(modal)="{item}">
                            <i class="far fa-list-alt font-size-18 text-primary" style="cursor:pointer" @click="showDetailsModal=true;selectedItem=item;getItemsManufacturers();" ></i>
                        </template> -->
                        </b-table>
                        <span v-if="!isSimilairItemsTableBusy && !similairItemsList.length" class="d-flex justify-content-center m-4 text-muted" >{{ $t("catalog.empty") }} </span>
                        <!-- Pagination -->
                        <!-- <div class="row pt-3 pl-2 mb-1">
                            <div class="col-sm-8">
                                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                    <b-form-select @input="getSimilairItems([cardItem])"  v-model="similairItemsPagemodel.perPage" size="sm" style="width: 5em" :options="[50]"></b-form-select>
                                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{similairItemsPagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <b-pagination v-model="similairItemsPagemodel.currentPage" :per-page="similairItemsPagemodel.pageSize" :total-rows="similairItemsPagemodel.totalRows" @input="getSimilairItems([cardItem])" :disabled="isSimilairItemsTableBusy" ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>  -->
                        <!-- Fin Pagination  -->
                      </div>
          
        
                    </b-card>
                  </div>
            </div>
            <!-- End Equivalences -->
            <!-- ---------------- -->


            <!-- --- -->
            <!-- KITS -->
            <div class="row d-print-none">
                  <div  class ="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                    <b-card id="kitItemsCard" no-body header-class="bg-transparent border-secondary" class="border border-muted border-2 mb-0 mt-4" > 
                      <div class="row" style="background-color:#eff2f7;">
                        <div class="col-12">
                          <h5 class="card-title mt-2 mb-2 text-warning text-center" >KITS {{cardItem ? "[" + cardItem.ref + "]" : ""}}</h5>
                        </div>
                        <!-- <div class="col-1 text-right ">
                            <i  class=" fas fa-times font-size-16 pr-4 pt-2 pb-2 text-danger" @click="showcard=false" style="cursor:pointer" :title="$t('datPicker.label-close-button')"> </i>
                        </div> -->
                      </div>
                      <div class="table-responsive mb-0">
                        <b-table
                          :striped="true"
                          :small="true"
                          :hover="true"
                          :no-border-collapse="true"
                          :busy="isKitItemsTableBusy"
                          :items="kitItemsList"
                          :fields="similairItemsFields"
                          
                        >
                        <template v-slot:head(ref)>
                          {{ $t("catalog.header.reference") }} 
                        </template>
                        <template v-slot:head(title)>
                          {{ $t("catalog.header.title") }} 
                        </template>
                        <!-- <template v-slot:head(position)>
                          {{ $t("catalog.header.shockAbsorberPosition") }} 
                        </template> -->
                        <template v-slot:head(brand)>
                          {{ $t("catalog.header.brand") }} 
                        </template>
                        <template v-slot:head(price)>
                          {{ $t("catalog.header.price") }} 
                        </template>
                        <!-- <template v-slot:head(discountStr)>
                          {{ $t("catalog.header.discount") }} 
                        </template> -->
                        <!-- <template v-slot:head(discountedPrice)>
                          {{ $t("catalog.header.discountedPrice") }} 
                        </template> -->
                        <!-- <template v-slot:head(modal)>
                          {{ $t("catalog.header.modal") }} 
                        </template> -->
                        <template v-slot:head(salesUnit)>
                          {{ $t("catalog.header.multiple") }} 
                        </template>
                        <template v-slot:head(stockStatus)>
                          {{ $t("catalog.header.stockStatus") }} 
                        </template>

                        <template v-slot:cell(salesUnit)="{item,value}">
                          <i v-if="item.isQtyInfo" @click="getImportQty(item)" class="fas fas fa-shipping-fast font-size-16 mr-4" style="color: #ffc107 !important; cursor:pointer;"/> {{value}} 
                        </template>

                        <template v-slot:cell(claim)="{item}">
                          <span @click="addClaim(item)" style="cursor:pointer;"><i class="mdi mdi-comment-text-multiple-outline font-size-18 text-danger" /></span>
                        </template>

                        <template v-slot:head(claim)>
                          Réclamation
                        </template>


                        <template v-slot:table-busy>
                          <div class="text-center my-2">
                              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                          </div>
                        </template>
                        <!-- <template v-slot:cell(discountStr)="{value}">
                          {{value == 0 || value ==null ? '_' : value+'%'}} 
                        </template> -->
                        <template v-slot:cell(price)="{item,value}">
                          <div :class="item.stockStatus == 2 ? 'text-danger' : item.stockStatus == 3 ? '' : 'text-primary'">{{value ? value : '_'}} </div>
                        </template>
                        <!-- <template v-slot:cell(discountedPrice)="{value}">
                          {{value ? value : '_'}} 
                        </template> -->
                        <template v-slot:cell(brand)="{value}">
                          {{value.name}} 
                        </template>

                        <template v-slot:cell(ref)="{item, value}">
                          <span>{{value}} <!--i style="vertical-align:middle; cursor:pointer;" class="dripicons-information text-warning font-size-14 ml-1" @click="getKitComponents(item);" v-if="item.isKit"> </i--></span>
                        </template>

                        <template v-slot:cell(info)="{item}">
                          <span v-if="item.hasInfo || item.isKit" @click="showItemAttributes(item)" style="cursor:pointer;" ><i class="fas fa-question-circle font-size-18 text-info" /></span>
                        </template>

                        <template  v-slot:cell(action)="{item}">
                          <div  class="input-group    mb-0" style="width: 7em;"  :class="!item.id || item.stockStatus >1 || (role ==1 && selectedCustomer == null)  ? 'd-none' : ''">
                            <b-form-input  type="number" :min="item.multiple > 1 ? item.multiple : 1" :step="item.multiple > 1 ? item.multiple : 1" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                              v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                            <div size="sm" class="input-group-append">
                              <button  type="button"  class="btn input-group-text text-success btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                                <i v-if="!isAddToOrderStarting"  class=" fas fa-plus-circle font-size-14"> </i>
                                <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                              </button>
                            </div>
                          </div>

                        </template>
                        <template  v-slot:cell(stockStatus)="{value}">
                            <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
                            <div v-else-if="value==3"  class="font-size-18"> _</div>
                            <i v-else :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
                        </template>
                        <!-- <template v-slot:cell(modal)="{item}">
                            <i class="far fa-list-alt font-size-18 text-primary" style="cursor:pointer" @click="showDetailsModal=true;selectedItem=item;getItemsManufacturers();" ></i>
                        </template> -->
                        </b-table>
                        <span v-if="!isKitItemsTableBusy && !kitItemsList.length" class="d-flex justify-content-center m-4 text-muted" >{{ $t("catalog.empty") }} </span>
                        <!-- Pagination -->
                        <!-- <div class="row pt-3 pl-2 mb-1">
                            <div class="col-sm-8">
                                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                    <b-form-select @input="getSimilairItems([cardItem])"  v-model="similairItemsPagemodel.perPage" size="sm" style="width: 5em" :options="[50]"></b-form-select>
                                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{similairItemsPagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <b-pagination v-model="similairItemsPagemodel.currentPage" :per-page="similairItemsPagemodel.pageSize" :total-rows="similairItemsPagemodel.totalRows" @input="getSimilairItems([cardItem])" :disabled="isSimilairItemsTableBusy" ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>  -->
                        <!-- Fin Pagination  -->
                      </div>
          
                      
        
                    </b-card>
                  </div>
            </div>
            <!-- KITS -->
            <!-- ---- -->
            
            <!-- --- -->
            <!-- OLD ORDERs BY ITEM -->
            <div class="row d-print-none">
                  <div  class ="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                    <b-card id="kitItemsCard" no-body header-class="bg-transparent border-secondary" class="border border-success border-2 mb-0 mt-4" > 
                      <div class="row" style="background-color:#bee3d1;">
                        <div class="col-12">
                          <h5 class="card-title ml-2 mt-2 mb-2 text-primary text-center" >ANCIENNES COMMANDES {{cardItem ? "[" + cardItem.ref + "]" : ""}}</h5>
                        </div>
                      </div>




                      <div class="table-responsive mb-0">

                       <b-table 
                        :busy="isOrdersByItemTableLoading"
                        :striped="true"

                        :small="false"
                        :hover="true"

                        :items="ordersByItemList"
                        :fields="ordersListFields"

                        :perPage="pagemodelOrdersByItem.perPage"
                        class="table  "
                        >
                        <template v-slot:table-busy>
                        <div class="text-center my-2">
                            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                        </div>
                        </template>

                      <template v-slot:head(submissionDate)>
                        {{ $t("ordersMenu.list.header.submissionDate") }} 
                      </template>

                      <template v-slot:head(ref)>
                        {{ $t("ordersMenu.list.header.ref") }} 
                      </template>

                      <template v-slot:head(itemsCount)>
                        {{ $t("ordersMenu.list.header.itemsCount") }} 
                      </template>

                      <template v-slot:head(total)>
                        {{ $t("ordersMenu.list.header.total") }} 
                      </template>

                      <template v-slot:head(totalWithTaxes)>
                        {{ $t("ordersMenu.list.header.totalWithTaxes") }} 
                      </template>

                      <template v-slot:head(customerName)>
                        {{ $t("ordersMenu.list.header.customerName") }} 
                      </template>

                      <template v-slot:head(isPartial)>
                        Liv Partielle
                      </template>

                      <template v-slot:head(status)>
                        {{ $t("ordersMenu.list.header.orderStatus") }} 
                      </template>

                      <template v-slot:head(submissionUserName)>
                        Vendeur
                      </template>

                      <!-- <template v-slot:head(deliveryStatus)>
                        {{ $t("ordersMenu.list.header.status") }} 
                      </template>

                      <template v-slot:head(billingStatus)>
                        {{ $t("ordersMenu.list.header.credit") }} 
                      </template> -->

                      <template v-slot:head(sageRef)>
                        {{ $t("ordersMenu.list.header.sageRef") }} 
                      </template>

                      <template v-slot:cell(actions)="{item}"> 
                        <!-- <router-link :to="{ path: '/orders/order', query: { orderId: item.id }}"> -->
                          <b-button v-if="item.linesCount" title="Ouvrir"  size="sm" @click="showViewOldOrderModal=true; viewOldOrderId=item.id"  variant="outline-primary" >
                                <i class="fas fa-file-import font-size-16 align-middle mr-0 mr-sm-2"></i>
                                <span class="d-none font-weight-bold d-sm-inline">{{ $t("ordersMenu.list.button")}}</span>
                          </b-button> 
                        <!-- </router-link> -->

                      </template>

                      <!-- <template v-slot:cell(export)="{item}">
                          <b-button title="Exporter"  size="sm"   variant="outline-info"  @click.prevent="exportEXCEL(item.id)" :disabled="exportOrdersInProgress"  >
                            <b-spinner small :class="exportOrdersInProgress ? 'mr-1' : 'd-none'"></b-spinner>
                            <i class="fas fa-file-excel  font-size-16  font-weight-bold align-middle mr-0 mr-sm-2"></i>
                            <span class=" font-weight-bold text-uppercase d-none d-sm-inline">{{ $t("ordersMenu.list.export")}} </span>         
                          </b-button> 
                      </template> -->

                      <template v-slot:cell(restartSync)="{item}">
                          <b-button v-if="isAdmin && item.extId == null && item.status != 0"  title="Sync" size="sm"   variant="outline-danger"  @click.prevent="restartSync(item.id)" :disabled="restartingSyncInProgress"  >
                            <b-spinner small :class="restartingSyncInProgress ? 'mr-1' : 'd-none'"></b-spinner>
                            <i class="fas fa-sync-alt  font-size-16  font-weight-bold align-middle  mr-0 mr-sm-2"></i>
                            <span class=" font-weight-bold text-uppercase d-none d-sm-inline">{{ $t("ordersMenu.list.restartSync")}}</span>         
                          </b-button> 
                      </template>

                      <template v-slot:cell(isPartial)="{value}">
                        <i v-if="value" title="Livraison Partielle" style="color:#ffcc00" class="fas fa-exclamation-circle font-size-20  font-weight-bold align-middle"></i>
                      </template>

                      <template v-slot:cell(status)="{item,value}">
                        <h5><b-badge href="#" :variant="statusToColor(value)">{{item.extStatusStr != null ? item.extStatusStr : $t("ordersMenu.statusLabel."+statusToLabel(item.status))}}</b-badge></h5>
                      </template>

                      <template v-slot:cell(submissionUserName)="{value}">
                        {{value}}
                      </template>

                      <!-- <template v-slot:cell(deliveryStatus)="{item,value}">
                        <h5><b-badge href="#" :variant="deliveryStatusToColor(value,item.status)">{{$t("ordersMenu.statusLabel."+deliveryStatusToLabel(value,item.status))}}</b-badge></h5>
                      </template>

                      <template v-slot:cell(billingStatus)="{item,value}">
                        <h5><b-badge href="#" :variant="billingStatusToColor(value,item.status)">{{$t("ordersMenu.billingStatus."+billingStatusToLabel(value,item.status))}}</b-badge></h5>
                      </template> -->

                        <template v-slot:cell(ref)="{item,value}">
                        <span :class="item.status ==0 ? 'text-danger' : ''">{{value}}</span>
                        </template>

                        <template v-slot:cell(submissionDate)="{item,value}">
                          <span v-if="item.status == 0" class="text-danger"><i class="mdi mdi-clock-outline mr-2"></i>{{ $t("ordersMenu.list.draft")}} ({{ item.date }})</span>
                          <span v-if="item.submissionDate">{{value}}</span>
                        </template>

                        <template v-slot:cell(sageRef)="{item}">
                            {{item.sageRef}}
                        </template>

                        </b-table>


                        <span v-if="!isOrdersByItemTableLoading && !ordersByItemList.length" class="d-flex justify-content-center m-4 text-muted" >{{$t('ordersMenu.list.empty')}} </span>
                        <!-- Pagination -->
                        <div class="row pt-3 pl-2 mb-1">
                            <div class="col-sm-8">
                                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                    <b-form-select @input="findOrdersByItem(cardItem.ref)"  v-model="pagemodelOrdersByItem.perPage" size="sm" style="width: 5em" :options="[5,10]"></b-form-select>
                                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodelOrdersByItem.totalRows}} {{ $t("pagination.lines") }}</span></div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <b-pagination v-model="pagemodelOrdersByItem.currentPage" :per-page="pagemodelOrdersByItem.pageSize" :total-rows="pagemodelOrdersByItem.totalRows" @input="findOrdersByItem(cardItem.ref)" :disabled="isSimilairItemsTableBusy" ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- Fin Pagination  -->
                      </div>
          
        
                    </b-card>
                  </div>
            </div>
            <!-- OLD ORDERs BY ITEM -->
            <!-- ------------------ -->

          </div>
        </div>
      </div>

      <!-- SECOND COLUMN OF PAGE -->
      <div   class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 pl-xl-3 pr-4">
        <div class="card h-100">
            <div class="card-body border border-primary card bg-Default">
              <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
                <b-tab ref="orderLines-tab"  lazy >
                  <template v-slot:title>
                    <span class="d-inline-block p-0 font-size-14">
                      <i class="fas fa-cart-plus mr-2 font-size-16"></i> COMMANDE
                      <!-- <br><span class="text-primary">Commandes</span> -->
                    </span>
                    <!-- <i class="d-none d-sm-inline-block fas fa-dolly font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.newOrderTab.title')}}</span> -->
                  </template>
                  <div >
                    <div style="min-height: 80em;">
                       <!-- <h5 class="card-title mt-3 mb-0 text-secondary text-center">{{$t('orderTabs.newOrderTab.cardTitle')}}</h5>
                      <h6 class="card-title pt-0 mt-1 mb-0 text-success text-center" :class="role==1 ? '' : 'd-none'">{{order.customerName}}</h6><br>  -->










        <div class="row pb-4 pt-4 d-print-none">
          <div  class ="col-12" >
         
   
                <!-- <div class="row pl-4 pr-4 pb-3">
                  <div class="col-6 text-left">
                    <div class="mt-3">
                      <p class="text-muted mb-1">{{$t("outstanding.inProgress")}}</p>
                      <h5>{{customerOutstandingInfo.inProgressStr}} </h5>
                    </div>
                  </div>

                  <div class="col-6 text-center">
                    <div class="mt-3">
                      <span class="text-muted mb-1">{{$t("outstanding.ceiling")}}</span>
                      <h5>{{customerOutstandingInfo.ceilingStr}} </h5>
                    </div>
                  </div>

                  
                </div> -->

                

                <div class="row">

                  
                  <div v-if="customerOutstandingInfo.inProgressStr && customerOutstandingInfo.ceilingStr" :class="customerOutstandingInfo.paymentConditionsPDFExist ? 'col-9' : 'col-12'">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item">
                        <div class="py-2">

                          <div class="pt-0 pb-4" :class="role==1 ? '' : 'd-none'">
                        <span v-if="this.selectedCustomer || this.order.customerName" class="text-muted font-weight-bold">Client Sélectionné : </span>
                        <h6 v-if="this.selectedCustomer" class="card-title pt-0 mt-1 mb-0 text-primary" >{{this.order.customerName != null ? this.order.customerName : this.selectedCustomer.name}}</h6> 
                      </div>

                          <div class="row mb-2">
                            <div class="col-6 text-left">
                              <h5 class="font-size-14 text-danger">Solde Client</h5>
                            </div>
                            <div class="col-6 text-right font-size-14 font-weight-bold text-danger">
                              {{customerOutstandingInfo.outstandingPaymentStr}}
                            </div>
                          </div>

                          <div class="row">
                            <!-- <div class="col-10 text-left">
                              <h5 class="font-size-14 text-primary">{{$t("outstanding.status")}}</h5>
                              <span class="text-success">{{customerOutstandingInfo.inProgressStr}} / <span class="text-success font-weight-bold">{{customerOutstandingInfo.ceilingStr}}</span></span>
                            </div> -->
                            <div class="col-12 text-right font-size-14 text-muted">
                              {{customerOutstandingInfo.status}}  %
                            </div>
                          </div>

                          
                        





                          <b-progress  
                              :value="customerOutstandingInfo.status" 
                              variant="success" 
                              height="6px" 
                          />
                          <!-- <div class="progress animated-progess progress-sm">
                            <div
                              class="progress-bar bg-warning"
                              role="progressbar"
                              style="width: 69%"
                              aria-valuenow="69"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div> -->
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div v-if="customerOutstandingInfo.paymentConditionsPDFExist" class="col-3 align-self-center text-center text-primary">
                      <a @click.prevent="downloadPaymentConditions()" :title="$t('outstanding.conditions.hover')" class="font-size-12 font-weight-bold text-center" style="cursor:pointer"><i class="fas fa-download  mr-1"></i>{{$t('outstanding.conditions.label')}} </a> 
                  </div>

                </div>
              </div>
              <div class="text-center" v-if="isGettingCustomerOutstandingInfo" >
                <!-- <b-spinner variant="primary" ></b-spinner> -->
             

            
          </div>
        </div>
















                      
                     
                      <div class="row pb-3 pt-3">
                        <div class="col-11 text-left" >

                            <h5 class="text-secondary mb-0 font-size-14">{{$t('orderTabs.newOrderTab.cardTitle')}}</h5>
                        </div>
                        <div class="col-1 text-right">
                          <a :title="$t('orderTabs.newOrderTab.clearOderButtonTitle')" href="javascript:void(0);"  @click="cancelOrder()" class="action-icon text-danger">
                          <i class="fas fa-times font-size-14" />
                        </a>  
                        </div>
                      </div>
                      <div class="table-responsive mb-0" >
                        <b-table
                            :striped="true"
                            :small="true"
                            :hover="true"
                            :items="orderLines"
                            :fields="orderFields"
                            sortKey="itemTitle"
                            responsive
                          >
                    <template v-slot:head(itemTitle)>
                      {{ $t("orderTabs.newOrderTab.orderFields.itemTitle") }} 
                    </template>
                    <template v-slot:head(quantity)>
                      {{ $t("orderTabs.newOrderTab.orderFields.quantity") }} 
                    </template>
                    <template v-slot:head(price)>
                      {{ $t("orderTabs.newOrderTab.orderFields.price") }} 
                    </template>
                    <template v-slot:cell(itemTitle)="{item}">
                        <a v-if="!item.isGratuity" :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeOrderLine(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                          <i class="mdi mdi-trash-can font-size-18" />
                        </a>  
                        <i v-if="item.isGratuity" class="fas fa-star text-info font-size-12 " />
                        <span class="text-black ml-2">{{item.ref}}</span>                                          
                    </template>
                    <template v-slot:cell(price)="{item}">
                        <span class="text-black ml-2">{{item.discountedPrice }}</span>                                          
                    </template>
                    <template v-slot:cell(quantity)="{value, item}">
                        <span v-if="!item.isOrderQuantityEdit" class="text-black">{{value}}</span>      
                        <a  v-if="!item.isOrderQuantityEdit && !item.isGratuity" @click="item.isOrderQuantityEdit = true" :title="$t('parameters.hover.editQty')" href="javascript:void(0);" :class="item.itemId ? '' : 'd-none'" class="action-icon text-warning">
                          <i class="fas fa-pencil-alt  ml-2 font-size-13"  @click="item.isOrderQuantityEdit = true; item.editedQuantity = item.quantity;"/>
                        </a>
                        <i v-if="item.isGratuity" class="fas fa-star text-info invisible  ml-2 font-size-12 " />

                        <div v-if="item.isOrderQuantityEdit" class="input-group input-group-sm pull-right mb-0" style="width:85px;">
                          <b-form-input v-model="item.editedQuantity" type="number"  size="sm" class="no-shadow p-1" @keyup.native.enter="editOrderLine(item)"></b-form-input>
                            <div class="input-group-append"  size="sm" >
                              <b-button variant="link"  size="sm" title="Changer la quantité"><i class="font-size-12 fas fa-pencil-alt text-warning" @click="editOrderLine(item)"></i></b-button>
                            </div>
                        </div>
                    </template>
                        </b-table>
                      </div>
                    </div>
                    <div >
                      <div class="table-responsive mt-4" >
                        <table class="table table-centered mb-0 table-nowrap table-sm borderless">
                          <tbody>
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.total") }}</h6>
                              </td>
                                                                    
                              <td class="text-right text-primary font-weight-bold">{{order.totalBeforeDiscount}}</td>
                            </tr> 
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.discountAmount") }}</h6>
                              </td>
                                                                    
                              <td class="text-right text-primary font-weight-bold">{{order.discountAmount}}</td>
                            </tr>  -->
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.total") }}</h6>
                              </td>
                              <td class="text-right">{{order.total}}</td>
                            </tr> -->
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.discountAmount") }}</h6>
                              </td>
                              <td class="text-right">{{order.discountAmount}}</td>
                            </tr>
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.taxes") }}</h6>
                              </td>
                              <td class="text-right">{{order.taxes}}</td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.vat") }}</h6>
                              </td>
                              <td class="text-right">{{order.vat}}</td>
                            </tr> -->
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.totalWithTaxes") }}</h6>
                              </td>
                              <td class="text-right text-primary font-weight-bold">{{order.totalWithTaxes}}</td>
                            </tr> -->
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.totalnet") }}</h6>
                              </td>
                              <td class="text-right text-primary font-weight-bold">{{order.total}}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="row pb-0 pt-3">
                          <div class="col-sm-12">
                              <b-button variant="warning" style="width:100%" @click="checkOrder()" :disabled="this.isCheckingOrder || !this.orderLines.length"> 
                                <b-spinner small :class="this.isCheckingOrder ? '' : 'd-none'"></b-spinner>
                                <i class="bx bx-check-double font-size-24 align-middle mr-2"></i> <span class="font-weight-bold font-size-14">{{$t("orderTabs.newOrderTab.validateOrderButton") }}</span>
                              </b-button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </b-tab>
                <!-- <b-tab  lazy >
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-question font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-question  font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.requestTab.title')}}</span>
                  </template>
                    <h5 class="card-title mt-3 mb-0 text-secondary text-center">{{$t('orderTabs.requestTab.cardTitle')}}</h5><br> 
                </b-tab> -->
                <b-tab @click="getDrafts()" lazy >
                  <template v-slot:title>
                    <span class="d-inline-block ">
                      <i class="fas fa-file-contract font-size-16"></i>
                    </span>
                    <!-- <i class="d-none d-sm-inline-block fas fa-archive font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.draftsTab.title')}}</span> -->
                  </template>
                  <h5 class="card-title mt-3 mb-0 text-secondary text-center">{{$t('orderTabs.draftsTab.cardTitle')}}</h5><br>
                  <div class="table-responsive mb-0" style="min-height:42em;max-height:42em">
                  <b-table
                      :busy="isDraftsTableLoading"
                      :striped="true"
                      :small="true"
                      :hover="true"
                      :items="draftLines"
                      :fields="draftFields"
                      sortKey="date"
                    >
                  <template v-slot:head(ref)>
                    {{ $t("orderTabs.draftsTab.draftFields.ref") }} 
                  </template>
                  <template v-slot:head(date)>
                    {{ $t("orderTabs.draftsTab.draftFields.date") }} 
                  </template>
                  <template v-slot:head(submissionUserName)>
                    {{ $t("orderTabs.draftsTab.draftFields.submissionUserName") }} 
                  </template>

                                    
                  <template v-slot:cell(submissionUserName)="{value}">
                        <span class="submission-user-name" v-b-tooltip.hover :title="value">{{ value && value.length > 12 ? value.slice(0, 12) + "..." : value }}</span>
                  </template>


                  <template v-slot:cell(ref)="{value,item}">
                        <a  title="" href="javascript:void(0);"  @click="getOrderLines(item)" >
                          {{value}}
                        </a>  
                  </template>
                  <template v-slot:cell(actions)="{item}">
                        <a  :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeDraft(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                          <i class="mdi mdi-trash-can font-size-18" />
                        </a>  
                  </template>
                  <template v-slot:table-busy>
                    <div class="text-center m-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  </b-table>
                  <span v-if="!isDraftsTableLoading & !draftLines.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("orderTabs.draftsTab.emptyDraftTable")}}</span>
                  <!-- Pagination -->
                  <div class="row pt-3">
                      <div class="col-sm-8">
                          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                              <b-form-select @input="getDrafts()"  v-model="draftsPagination.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-1 ml-1">{{$t("pagination.from")}}</span><span class="font-weight-bold"> {{draftsPagination.totalRows}} {{$t("pagination.lines")}}</span></div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                              <ul class="pagination pagination-rounded mb-0">
                              <b-pagination v-model="draftsPagination.currentPage" :per-page="draftsPagination.pageSize" :total-rows="draftsPagination.totalRows" @input="getDrafts()" :disabled="isDraftsTableLoading" ></b-pagination>
                              </ul>
                          </div>
                      </div>
                  </div> 
                  <!-- Fin Pagination  -->
                  </div> 

                </b-tab>
              </b-tabs>
              
            </div>
        </div>
      </div>

    </div>















    <!-- <b-modal v-if="selectedItem"
            v-model="showDetailsModal"
            :title="$t('catalog.modal.title') + ' [' + selectedItem.ref + ']'"
            centered 
            hide-footer
            title-class="text-primary"
            title-tag="h5"
            hide-header
            header-close-variant="danger"
            size="md">

            
            <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold"> 
              
              <b-tab active :title="'COMPOSANTS DU KIT' + ' [' + selectedItem.ref + ']'" title-item-class="mb-4"  style="height:500px;">

                  <simplebar style="max-height: 500px; min-height:500px">
                    <div class="table-responsive mb-0" style="max-height: 500px; min-height:500px">
                      <table class="table table-nowrap table-centered table-hover" >
                          <tbody>
                              <tr v-for="data  in this.kitComponents" :key="data.ref">
                                <td>
            
                                  <span class="text-dark font-weight-bold font-weight-16">{{data.count}} x </span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-bold  font-weight-16">{{data.ref}}</span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-16">{{data.title}}</span>
                                </td>
                          
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </simplebar>  
              </b-tab>
            </b-tabs>

            

    </b-modal> -->



    <b-modal v-if="selectedItem"
            v-model="showAttributesModal"
            :title="$t('catalog.modal.title') + ' [' + selectedItem.ref + ']'"
            centered 
            hide-footer
            title-class="text-primary"
            title-tag="h5"
            hide-header
            header-close-variant="danger"
            size="lg">

            <h5 class="mb-4 text-center text-warning font-weight-bold">
                Article [{{selectedItem.ref }}]
            </h5>
            
            <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold"> 
              
              <b-tab active title="Image" title-item-class="mb-0" style="height:500px;">
                  <div class="pt-4">
                    <img v-bind:src="'/api/image/get/ext/' + this.selectedItem.id"  style="display: block; margin-left: auto; margin-right: auto;" />
                  </div>

              </b-tab>              

              <b-tab v-if="this.itemAttributes && this.itemAttributes.length > 0" title="Attributs" title-item-class="mb-0" style="height:500px;">
                    <simplebar style="max-height: 500px; min-height:500px">
                    <div class="table-responsive mb-0" style="max-height: 500px; min-height:500px">
                      <table class="table table-nowrap table-centered table-hover" >
                          <tbody>
                              <tr v-for="data  in this.itemAttributes" :key="data.key">
                                <td>
            
                                  <span class="text-dark font-weight-bold font-weight-16">{{data.key}}</span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-16">{{data.value}}</span>
                                </td>
       
                          
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </simplebar>  
                  

              

                  
              </b-tab>

              <b-tab :title="'COMPOSANTS DU KIT' + ' [' + selectedItem.ref + ']'" title-item-class="mb-0" @click="getKitComponents(selectedItem);" v-if="selectedItem.isKit" style="height:500px;">

                  <simplebar style="max-height: 500px; min-height:500px">
                    <div class="table-responsive mb-0" style="max-height: 500px; min-height:500px">
                      <table class="table table-nowrap table-centered table-hover" >
                          <tbody>
                              <tr v-for="data  in this.kitComponents" :key="data.ref">
                                <td>
            
                                  <span class="text-dark font-weight-bold font-weight-16">{{data.count}} x </span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-bold  font-weight-16">{{data.ref}}</span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-16">{{data.title}}</span>
                                </td>
                          
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </simplebar>  
              </b-tab>

              
            </b-tabs>


    </b-modal>


    <b-modal v-if="selectedItem"
            v-model="showQuantityModal"
            :title="$t('catalog.modal.title') + ' [' + selectedItem.ref + ']'"
            centered 
            hide-footer
            title-class="text-primary"
            title-tag="h5"
            hide-header
            header-close-variant="danger"
            size="md">

            
            <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold"> 
              
              <b-tab active :title="'PROCHAINS ARRIVAGES' + ' [' + selectedItem.ref + ']'" title-item-class="mb-4" style="">

                  <!-- <simplebar style="max-height: 500px; min-height:500px"> -->
                    <div class="table-responsive mb-0" style="">
                      <table class="table table-nowrap table-centered table-hover" >
                          <tbody>

                            <tr>
                                <td>
            
                                  <span class="text-dark font-weight-bold font-weight-16">Qté Réception </span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-bold  font-weight-16">{{quantityInfo.qteReception ? quantityInfo.qteReception : '-'}}</span>
                                </td>
                          
                              </tr>

                              <tr>
                                <td>
            
                                  <span class="text-dark font-weight-bold font-weight-16">Stock Import </span>

                                  

                                  <span class="text-muted" v-for="importDate in quantityInfo.stockImportDates" :key="importDate.date">
                                      <br/><i class="text-info">{{ importDate.date }} </i> <span class=" text-info ml-4">{{ importDate.qty }}</span> 
                                  </span>

                                  
                                  
                                  <!-- <br/><span class="text-muted "></span>
                                  <br/><span class="text-muted "><i class="font-weight">12/05/2022 </i> <span class="ml-3">10</span> </span>
                                  <br/><span class="text-muted "><i class="font-weight">12/05/2022 </i> <span class="ml-3">10</span> </span> -->

                                </td>
                                <td style="vertical-align:top !important;">
                                  <span class="text-dark font-weight-bold  font-weight-16">{{quantityInfo.stockImport ? quantityInfo.stockImport : '-'}}</span>
                                  
                                </td>
                          
                              </tr>
                              
                              <tr>
                                <td>
            
                                  <span class="text-dark font-weight-bold font-weight-16">Qté Commandée sur Achat </span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-bold  font-weight-16">{{quantityInfo.qtyPurchaseOrder ? quantityInfo.qtyPurchaseOrder : '-'}}</span>
                                </td>
                          
                              </tr>

                          </tbody>
                      </table>
                    </div>
                  <!-- </simplebar>   -->
              </b-tab>
            </b-tabs>

    </b-modal>


    <b-modal
      v-if="order.id "
      v-model="showOrdersDetailsModal"
      title="Valider la commande"
      centered 
      title-class="text-primary d-print-none"
      title-tag="h5"
      header-close-variant="danger"
      header-class="d-print-none"
      class="modal-fullscreen"
      size="xl"
      full-screen
      no-close-on-esc
      hide-footer
      >

      <OrderModal :orderId="this.order.id" v-on:update="closeOrderModal" :warningMessage="warningMessage" />
    </b-modal>

    <b-modal
      v-if="viewOldOrderId "
      v-model="showViewOldOrderModal"
      title="Ancienne commande"
      centered 
      title-class="text-primary d-print-none"
      title-tag="h5"
      header-close-variant="danger"
      header-class="d-print-none"
      class="modal-fullscreen"
      size="xl"
      full-screen
      no-close-on-esc
      hide-footer
      >

      <!-- <OrderModal :orderId="this.viewOldOrderId" /> -->


      <Order class="mt-0" :orderId="this.viewOldOrderId" isCatalogList="true"/> 


    </b-modal>

    <b-modal
      v-if="role==0"
      v-model="showHistoryModal"
      :title="$t('topItems.historyModal.title')"
      centered 
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      hide-footer
      size="lg">
      <OrdersList :isHomePage=true />
    </b-modal>


    <!-- Add Claim modal -->
    <b-modal v-if="selectedItem"
            v-model="showAddClaimModal"
            :title="$t('catalog.modal.title') + ' [' + selectedItem.ref + ']'"
            centered 
            hide-footer
            title-class="text-primary"
            title-tag="h5"
            hide-header
            header-close-variant="danger"
            size="md">

            
            <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold"> 
              
              <b-tab active :title="'Ajouter une Réclamation sur ' + ' [' + selectedItem.ref + ']'" title-item-class="mb-0">

                  <form class="form-horizontal mt-4" role="form">
           
                    <div class="form-group row mb-2">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pr-sm-2 pr-0">
                        <label class="font-size-14">Type de Réclamation</label>
                        <v-select class="pb-2 font-size-16"   :options="optionsClaimType" v-model="selectedClaimType" placeholder="Sélectionner une catégorie de réclamation" label="name" >
                            <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>ssss
                        </v-select> 
                      </div>
                    </div>        
        
        
                    <div class="form-group row mt-0 mb-2">
                      <label class="col-md-12 col-form-label font-size-14">Détails de la réclamation <span class="text-muted font-size-10" style="font-size:10px !important;" >(optionnel)</span> :</label>
                      <div class="col-md-12">
                          
                          <textarea
                            v-model="claimMessage"
                            class="form-control"
                            :maxlength="250"
                            rows="3"
                            placeholder="Ajouter quelques détails à votre réclamation si vous le souhaitez"
                          ></textarea>
                          <div class="text-center">
                            <p
                              v-if="claimMessage"
                              class="badge position-absolute "
                              :class="{ 'badge-success': claimMessage.length !== 250,
                                        'badge-danger': claimMessage.length === 250 }"
                            >
                              {{ claimMessage.length }} /
                              250
                            </p>
                          </div>
                      </div>
                    </div>

                  </form> 

                  <div class="row pt-4 d-print-none" >
                    <div class="col-md-12 col-sm-12 d-print-none pr-0 ">
                        <b-button :variant="this.selectedClaimType ? 'warning' : 'secondary'" style="width:100%" size="lg" @click="submitClaim(selectedItem.id, selectedItem.ref)" :disabled="!this.selectedClaimType" >
                            <i class="fas fa-comment font-size-18 align-middle mr-2"></i> <span class="font-weight-bold font-size-14">Envoyer la Réclamation</span>
                        </b-button>
                    </div>
                </div> 
              </b-tab>
            </b-tabs>

    </b-modal>

    <b-modal
      v-model="showClaimModal"
      title="Nouvelle réclamation"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <!-- Reference Section: Simple and subtle -->
      <div class="reference-section mb-4">
        <span class="text-dark small">Référence Article:</span> 
        <span class="font-weight-bold ml-1">{{ claimReference }}</span>
      </div>

      <!-- Type Selection: Clean Button Group -->
      <div class="form-group mb-4">
        <label class="label-sm">Type de réclamation</label>
        <div class="btn-group-custom" :key="claimFormKey">
          <b-button
            size="sm"
            :variant="claimForm.refType == 1 ? 'warning' : 'outline-secondary'"
            @click="setRefType(1)"
          >
            <i class="fas fa-check-circle me-1"></i>
            Origine
          </b-button>

          <b-button
            size="sm"
            :variant="claimForm.refType == 2 ? 'warning' : 'outline-secondary'"
            @click="setRefType(2)"
          >
            <i class="fas fa-sync-alt me-1"></i>
            Adaptable
          </b-button>

          <b-button
            size="sm"
            :variant="claimForm.refType == 3 ? 'warning' : 'outline-secondary'"
            @click="setRefType(3)"
          >
            <i class="fas fa-times-circle me-1"></i>
            Ignorer
          </b-button>
        </div>
      </div>

      <!-- Manufacturer Section -->
      <div class="form-group mb-4">
        <label class="label-sm">Fabricant <small class="text-muted">(optionnel)</small></label>
        <v-select
          class="style-vselect simple-select"
          placeholder="Sélectionner une marque"
          :options="brandsList"
          v-model="claimForm.brand"
          label="name"
        >
          <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
        </v-select>
      </div>

      <!-- Footer: Clean and aligned -->
      <div class="modal-actions">
        <b-button
          variant="link"
          class="text-muted mr-auto"
          @click="showClaimModal = false"
        >
          Annuler
        </b-button>

        <b-button
          variant="danger"
          class="px-4"
          @click="submitClaimInvalidItem"
        >
          Envoyer
        </b-button>
      </div>
    </b-modal>

  </div>

   
</Layout>
</template>

<style lang="css" scoped>
/* Reference styling */
.reference-section {
    padding: 8px 12px;
    border-radius: 6px;
    display: inline-block;
    width: 100%;
    text-align: center;
    font-size: 20px;
}

/* Label styling */
.label-sm {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
}

.btn-group-custom {
    display: flex;
    background: #f1f3f5;
    padding: 4px;
    border-radius: 12px;
    gap: 4px;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.08);
}

.btn-group-custom .btn {
    flex: 1;
    border: none !important;
    border-radius: 10px !important;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 14px;
    transition: all 0.25s ease;
}

/* Boutons non sélectionnés */
.btn-group-custom .btn-outline-secondary {
    background: transparent;
    color: #6c757d;
}

/* Bouton sélectionné */
.btn-group-custom .btn-primary {
    background: linear-gradient(135deg, #0d6efd, #3b82f6);
    color: white;
    box-shadow: 0 4px 12px rgba(13, 110, 253, 0.35);
    transform: translateY(-1px);
}

/* Hover */
.btn-group-custom .btn:hover {
    transform: translateY(-1px);
}

.btn-group-custom .btn-primary:hover {
    box-shadow: 0 6px 16px rgba(13, 110, 253, 0.45);
}

/* V-Select styling */
.simple-select >>> .vs__dropdown-toggle {
    border: 1px solid #ced4da !important;
    border-radius: 6px !important;
    font-size: 14px !important;
}

/* Footer actions */
.modal-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

/* Make the cancel button look like a clean text link */
.btn-link {
    text-decoration: none;
    font-size: 14px;
}
</style>










<style lang="css" scoped>
.simulation-container {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 12px 20px;
    border-radius: 16px;
    border: 1px solid #eef2f7;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
}

.selection-side {
    width: 100%;
}

.selection-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    color: #4a5568;
    font-size: 13px;
    font-weight: 600;
}

.style-vselect-integrated >>> .vs__dropdown-toggle {
    border: 1px solid #e2e8f0 !important;
    border-radius: 10px !important;
    padding: 4px 12px !important;
    background: #f8fafc !important;
}

.info-side {
    width: 100%;
}

.customer-details-row {
    display: flex;
    align-items: center;
    gap: 18px;
    width: 100%;
    overflow: hidden; /* Prevents container from expanding */
}

.customer-identity {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    min-width: 130px;
    max-width: 190px;
    flex: 0 0 auto;
    padding-right: 18px;
    border-right: 1px solid #edf2f7;
}

.company-name {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #2d3748;
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
}

.company-name-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    flex: 1 1 auto;
}

.customer-code {
    font-size: 11px;
    color: #a0aec0;
    text-transform: uppercase;
}

/* 2-column grid: each value gets ~double the width vs a single row */
.details-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 18px;
    flex: 1 1 auto;
    min-width: 0; /* CRITICAL: allows grid children to shrink below content size */
}

.detail-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #4a5568;
    min-width: 0; /* CRITICAL for ellipsis to work */
}

.detail-item i {
    font-size: 16px;
    flex-shrink: 0;
}

.detail-value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; /* The Ellipse */
    display: block;
}

.submission-user-name {
    display: block;
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* RESPONSIVE DESIGN */
@media (max-width: 992px) {
    .customer-details-row {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }

    .customer-identity {
        max-width: none;
        padding-right: 0;
        padding-bottom: 8px;
        border-right: none;
        border-bottom: 1px solid #edf2f7;
    }

    .details-grid {
        grid-template-columns: 1fr;
        gap: 6px;
        width: 100%;
    }

    .detail-item {
        width: 100%;
        background: #f8fafc;
        padding: 6px 12px;
        border-radius: 8px;
    }
}
</style>
